import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import _ from 'lodash';
let SelectedNodesModelImpl = class SelectedNodesModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = [];
    }
    get selectedNodeIds() {
        return _.cloneDeep(this._modelData);
    }
    updateSelectedNodeIds(selectedNodeIds) {
        this.updateData(selectedNodeIds);
    }
    dispose() {
        this.updateData([]);
    }
    updateData(data) {
        this.update(() => {
            return data;
        });
    }
};
SelectedNodesModelImpl = __decorate([
    injectable()
], SelectedNodesModelImpl);
export { SelectedNodesModelImpl };
